import { css } from '@emotion/css';
import React from 'react';
import { ConfirmButton } from '../buttons/ConfirmButton';
import { NormalButton } from '../buttons/NormalButton';

export interface ConfirmDeleteProps {
  title: string;
  description: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirmClick: () => void;
  onCancelClick: () => void;
  errorMessage?: string;
  isLoading?: boolean;
}

export const ConfirmDelete: React.FC<ConfirmDeleteProps> = ({
  title,
  description,
  confirmLabel,
  cancelLabel,
  onConfirmClick,
  onCancelClick,
  errorMessage,
  isLoading
}) => {
  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        .title {
          font-size: 20px;
          text-align: center;
          color: #4d3906;
          animation-delay: 0.1s;
        }
        .desc {
          flex: 1 1 auto;
          padding: 12px 0 20px;
          animation-delay: 0.2s;
        }
        .error {
          color: #e60012;
          font-size: 12px;
          text-align: center;
          margin: 8px auto;
        }
        .button {
          width: 100%;
          margin: 8px 0 0;
        }
        @media (max-width: 369px) {
          .desc {
            font-size: 14px;
          }
        }
      `}
    >
      <p className="title">{title}</p>
      <p className="desc">{description}</p>
      {errorMessage && <p className="error">{errorMessage}</p>}
      <div className="button">
        <ConfirmButton background="#E60012" onClick={onConfirmClick} loading={isLoading}>
          {confirmLabel}
        </ConfirmButton>
      </div>
      <div className="button">
        <NormalButton onClick={onCancelClick} disabled={isLoading}>
          {cancelLabel}
        </NormalButton>
      </div>
    </div>
  );
};
